module.exports = __webpack_public_path__ + "img/01.4769f2bc.jpg";